import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import classNames from 'classnames';
import { useConfig } from '../../../contexts/config-context';
import { SignatureDrawer } from './signature-drawer';
import { getColor } from '../utils/drawer';
import styles from './signature-drawer-wut.module.scss';
import { ForcedState, useForcedState } from '../../../contexts/forced-state-context';
export const SignatureDrawerWUT = _ref => {
  let {
    hasError,
    required,
    ...props
  } = _ref;
  const {
    compId
  } = useConfig();
  const inputColor = getColor(compId, '--wix-forms-formInputValueColor');
  const penColor = inputColor && `rgb(${inputColor})`;
  const forcedState = useForcedState();
  const forcedError = forcedState.includes(ForcedState.INPUT_FIELDS_ERROR);
  const forcedHover = forcedState.includes(ForcedState.INPUT_FIELDS_HOVER);
  return /*#__PURE__*/React.createElement(SignatureDrawer, _extends({}, props, {
    className: classNames(styles.container, {
      [styles.error]: hasError || forcedError,
      [styles.hover]: forcedHover
    }),
    penColor: penColor
  }));
};
//# sourceMappingURL=signature-drawer-wut.js.map